import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, G } from "react-native-svg";
import AppTheme from "../../../AppTheme";
import MoodColors from "../MoodColors";

export default function NeutralIcon(props) {
  const color = props.color || MoodColors.Neutral;
  const opacity = props.selected ? 1 : AppTheme.moodOpacity;
  const width = props.width || 37;
  const height = props.height || 37;

  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 37 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G opacity={opacity}>
          <Path
            d="M31.1838 31.1838C38.2132 24.1543 38.2132 12.7574 31.1838 5.72792C24.1543 -1.30152 12.7574 -1.30152 5.72792 5.72792C-1.30152 12.7574 -1.30152 24.1543 5.72792 31.1838C12.7574 38.2132 24.1543 38.2132 31.1838 31.1838Z"
            fill={color}
          />
          <Path
            d="M25.5013 19.7314C26.4125 19.7314 27.1513 18.9926 27.1513 18.0814C27.1513 17.1701 26.4125 16.4314 25.5013 16.4314C24.59 16.4314 23.8513 17.1701 23.8513 18.0814C23.8513 18.9926 24.59 19.7314 25.5013 19.7314Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M25.8286 17.8695C26.0623 17.8695 26.2517 17.6801 26.2517 17.4464C26.2517 17.2127 26.0623 17.0232 25.8286 17.0232C25.5949 17.0232 25.4054 17.2127 25.4054 17.4464C25.4054 17.6801 25.5949 17.8695 25.8286 17.8695Z"
            fill="white"
          />
          <Path
            d="M28.4528 13.178C27.1397 12.2363 25.2904 12.1103 23.8602 12.8653"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M8.8139 13.1188C10.0975 12.1374 11.9437 11.9547 13.395 12.667"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M12.2991 19.89C13.2104 19.89 13.9491 19.1512 13.9491 18.24C13.9491 17.3287 13.2104 16.59 12.2991 16.59C11.3878 16.59 10.6491 17.3287 10.6491 18.24C10.6491 19.1512 11.3878 19.89 12.2991 19.89Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M12.6983 18.0282C12.932 18.0282 13.1214 17.8387 13.1214 17.605C13.1214 17.3713 12.932 17.1818 12.6983 17.1818C12.4645 17.1818 12.2751 17.3713 12.2751 17.605C12.2751 17.8387 12.4645 18.0282 12.6983 18.0282Z"
            fill="white"
          />
          <Path
            d="M14.8051 26.1728H23.6138"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.928161"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
        </G>
      </Svg>
    </TouchableOpacity>
  );
}
